import { VanDijkWebShellRoutingModule } from './vandijk-web-shell-routing.module';
import { inject, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { RouteReuseStrategy } from '@angular/router';
import { AnimalSelectionTabRouteReuseStrategy } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/animal-selection';
import { AnimationService, FontawesomeTypeService, LanguageService } from '@tcc-mono/shared/ui/theming';
import { FontawesomeImportModule } from '@tcc-mono/vandijk/shared/ui/fontawesome-import';
import { AnimalSelectionShellModule } from '@tcc-mono/vandijk/shared/features/animal-selections/feature/animal-selection-shell';
import { TccCoreAuthModule } from '@tcc-mono/shared/authentication/tcc-core-auth';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { PAGE_LAYOUT_TOOLBAR_END } from '@tcc-mono/shared/ui/page-layout';
import { WebNotificationsBellComponent } from './web-notifications/web-notifications-bell.component';

@NgModule({
  imports: [
    BrowserModule,
    VanDijkWebShellRoutingModule,
    HttpClientModule,
    FontAwesomeModule,
    FontawesomeImportModule,
    TccCoreAuthModule.forRoot(),
    AnimalSelectionShellModule.forRoot({
      source: 'web'
    }),
    WebNotificationsBellComponent
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: AnimalSelectionTabRouteReuseStrategy
    },
    {
      provide: PAGE_LAYOUT_TOOLBAR_END,
      useValue: WebNotificationsBellComponent
    }
  ]
})
export class VanDijkWebShellModule {
  private readonly _animationService = inject(AnimationService);
  private readonly _fontawesomeService = inject(FontawesomeTypeService);
  private readonly _languageService = inject(LanguageService);
  private readonly _faLib = inject(FaIconLibrary);

  constructor() {
    this._animationService.initTheme();
    this._fontawesomeService.initTheme();
    this._languageService.initLang();
    this._faLib.addIconPacks(fal);
  }
}
